type CursorPage<T> = { items?: T[]; meta?: { next?: string | null } };
type OffsetPage<T> = { items?: T[]; meta?: { exactTotal?: number } };

export async function collectCursorPages<T>(loadPage: (after?: string) => Promise<CursorPage<T>>): Promise<T[]> {
  const items: T[] = [];
  const seenCursors = new Set<string>();
  let after: string | undefined;

  for (;;) {
    const page = await loadPage(after);
    items.push(...(page.items ?? []));
    const next = page.meta?.next || undefined;
    if (!next || seenCursors.has(next)) return items;
    seenCursors.add(next);
    after = next;
  }
}

export async function collectOffsetPages<T>(loadPage: (offset: number) => Promise<OffsetPage<T>>, pageSize: number): Promise<T[]> {
  const items: T[] = [];

  for (;;) {
    const page = await loadPage(items.length);
    const current = page.items ?? [];
    items.push(...current);
    if (current.length === 0 || (page.meta?.exactTotal !== undefined
      ? items.length >= page.meta.exactTotal
      : current.length < pageSize)) return items;
  }
}
